import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToPrettyFormat'
})
export class SecondsToPrettyFormatPipe implements PipeTransform {

  transform(value: number, addTotalSeconds: boolean = false): string {
    if(!value) return '-';
    if(value < 120) return `${value.toFixed(0)} Sekunden`;
    let minutes = parseInt((value/60).toFixed(0));
    if(minutes < 120) return `ca. ${minutes} Minuten` + (addTotalSeconds? ` (${value} Sekunden)`: '');
    let hours = parseInt((minutes/60).toFixed(0));
    if(hours < 48) return `ca. ${hours} Stunden` + (addTotalSeconds? ` (${value} Sekunden)`: '');
    var days = hours / 24;
    return `ca. ${days.toFixed(0)} Tage` + (addTotalSeconds? ` (${value} Sekunden)`: '');
  }

}
